import React from 'react';
import {FormattedMessage} from 'react-intl';
import ReactDOM from 'react-dom';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';


export default class SliderRow extends React.Component {

    constructor(props) {
        super(props);

        this.state = {value: this.props.value || this.props.defaultValue};

        this.changeValue = this.changeValue.bind(this);
        this.getValue = this.getValue.bind(this);
    }

    componentWillReceiveProps(nextProps) {

        /* If it's a controlled slider (has the "onChange" and "value" props),
         * then update it's value when the value prop changes.
         */
        if (nextProps.value !== this.state.value) {
            this.changeValue(nextProps.value);
        }

    }

    changeValue(value) {
        let thisComponent = ReactDOM.findDOMNode(this),
            slider = thisComponent.querySelectorAll('.rc-slider-handle')[0];

        this.setState({value: value});

        if (value === this.props.min) {
            slider.classList.add('first-value');
        } else {
            slider.classList.remove('first-value');
        }

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value, this.props.onChangeData);
        }
    }

    getValue() {
        return this.state.value;
    }

    render() {

        return (
            <div className="slider-row">

                {
                    this.props.label ?
                        <div className="slider-label">
                            <FormattedMessage id={this.props.label}/>
                        </div> : null
                }

                <Slider dots={true}
                        value={this.state.value}
                        defaultValue={this.props.defaultValue}
                        min={this.props.min}
                        max={this.props.max}
                        onChange={this.changeValue}/>
            </div>
        );

    }

}


// WEBPACK FOOTER //
// ./src/scripts/reusable/Form/SliderRow.jsx